import axios from "axios";
import { fixToken } from "../utils/pipes/pipes";
import { deleteCookie } from "../services/commonMethods";
import { t } from "i18next";

let XSRF_TOKEN = "";
const RESTRICTED_URL = [];
export const XSRF_RESPONSE_KEY = "hhpctef";
export const XSRF_REQUEST_KEY = "X-Xsrf-Token";

export const setXsrfToken = (token) => {
  XSRF_TOKEN = token;
};
export const getXsrfToken = () => {
  return XSRF_TOKEN;
};

axios.interceptors.request.use(
  function (config) {
    const find = RESTRICTED_URL.find((ele) => config.url.includes(ele));
    if (!find) {
      const XSRF_TOKEN = getXsrfToken(XSRF_RESPONSE_KEY);
      if (XSRF_TOKEN) {
        config.headers = {
          ...config.headers,
          [XSRF_REQUEST_KEY]: XSRF_TOKEN
        }
      }
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    if (response?.headers && response.headers.get(XSRF_RESPONSE_KEY)) {
      const token = fixToken(response.headers.get(XSRF_RESPONSE_KEY));
      setXsrfToken(token);
    }
    return response;
  },
  (error) => {
    console.log(typeof (error?.response?.status));
    if (error?.response?.status === 401) {
      deleteCookie("token");
      window.location.href = process.env.REACT_APP_USER_LOGIN_URL;
    }
    if (error?.response?.status === 403) {
      let errorMsg = "You do not have access on this feature.";
      return {
        ...error, response: {
          ...error?.response,
          data: {
            error: {
              code: error?.response?.status,
              description: errorMsg,
              key: "",
              message: errorMsg,
            },
          },
        }
      };
    }
    if ((error?.response?.status >= 500 && error?.response?.status < 1000) || !error?.response?.status) {
      let errorMsg = "We are facing some connectivity issue with our system. Requesting you to please come back and retry after some time";
      const newError = {
        ...error, response: {
          ...error?.response,
          data: {
            error: {
              code: error?.response?.status,
              description: errorMsg,
              key: "",
              message: errorMsg,
            },
          },
        }
      };
      return newError;
    }
    return error;
  }
);
